<template>
  <v-container fluid ma-0 pa-0 full-width>
    <v-card-title v-if="showTabs" class="white" style="margin: 0px;padding: 0px;">
      <v-layout row full-width>
        <v-tabs v-model="activatedTab" fixed-tabs slider-color="primary">
          <v-tab v-for="(item, index) in tabs" :key="index" v-show="item.show">
            {{item.title}}
          </v-tab>
        </v-tabs>
        <v-spacer></v-spacer>
        <v-tooltip bottom v-show="activatedTab>0">
          <template slot="activator">
            <v-btn icon flat @click="returnPre" color="primary">
              <v-icon large>mdi-hand-pointing-left</v-icon>
            </v-btn>
          </template>
          <span>返回</span>
        </v-tooltip>
      </v-layout>
    </v-card-title>
    <v-tabs-items v-model="activatedTab" class="transparent">
      <v-tab-item v-for="(item, index) in tabs" :key="index">
        <slot :name="'page-'+index" :tab="item" :active="activatedTab">
          <gh-page v-model="activatedTab" :drawer.sync="item.drawer" :is-mini.sync="item.mini">
            <template #left-drawer>
              <slot :name="'tab'+index+'-left-drawer'"></slot>
            </template>
            <template #toolbar>
              <slot :name="'tab'+index+'-toolbar'"></slot>
            </template>
            <slot :name="'tab'+index" :index="index" :item="item">
            </slot>
          </gh-page>
        </slot>

      </v-tab-item>
    </v-tabs-items>

  </v-container>
</template>

<style scoped>

</style>

<script>
  import GhTabsPage from "./ghTabsPage.ts";
  export default GhTabsPage;
</script>